import { VariableGroup } from "@/types";

export const getThreshold = (queryGroups: Array<VariableGroup>, mode: string) => {
  if (queryGroups.length > 1 || queryGroups[0].variables.length > 1) {
    return mode === "broad" ? 100 : mode === "narrow" ? 140 : 120;
  } else {
    return mode === "broad" ? 100 : mode === "narrow" ? 140 : 120;
  }
};
